module.exports = __webpack_public_path__ + "img/List.ef5f891e.svg";